import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiItemsListHelperService } from '@fi-shared/fi-items-list/fi-items-list-helper.service';
import { IUserModel } from '@fi-shared/models/user.model';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { ObjectTypes } from '@fi-shared/types';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';

@Component({
    selector: 'fi-user-list-extended-search',
    template: `
        @if (loading$ | async) {
          <div class="text-center">
            <fi-loading class="small"></fi-loading>
          </div>
        }
        @if (userListViewSettings$ | async; as userListViewSettings) {
          <fi-user-list
            [userListViewSettings]="userListViewSettings"
            [extendedSearchMode]="true"
            (selectionChanged)="onSelectionChanged($event)"
            >
          </fi-user-list>
        }
        `,
    styleUrls: ['./fi-user-list-extended-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-list-extended-search' },
    standalone: false,
})
export class FiUserListExtendedSearchComponent {
    protected userListViewSettings$ = new ReplaySubject<ListViewSettingModel>(1);
    protected loading$ = new BehaviorSubject<boolean>(true);

    constructor(
        private itemsListHelperService: FiItemsListHelperService,
        listViewSettingsService: ListViewSettingsService,
    ) {
        listViewSettingsService
            .getSetting(ObjectTypes.User)
            .then((listViewSettings) => {
                this.userListViewSettings$.next(listViewSettings);
            })
            .finally(() => this.loading$.next(false));
    }

    onSelectionChanged($event: IUserModel[]) {
        this.itemsListHelperService.triggerExtendedSearchSelectionChanged($event);
    }
}
